import i18n from "../i18n";
import { formatTranslation } from "../shared/utils/translationUtils";

export const SupportedLanguages = [
  {
    value: "en",
    label: formatTranslation(i18n.t("languages.en")),
    shortLabel: "EN",
  },
  {
    value: "en-GB",
    label: formatTranslation(i18n.t("languages.enGB")),
    shortLabel: "En-GB",
  },
  {
    value: "bg",
    label: formatTranslation(i18n.t("languages.bg")),
    shortLabel: "BG",
  },
  {
    value: "cs",
    label: formatTranslation(i18n.t("languages.cs")),
    shortLabel: "CS",
  },
  {
    value: "fr",
    label: formatTranslation(i18n.t("languages.fr")),
    shortLabel: "FR",
  },
  {
    value: "de",
    label: formatTranslation(i18n.t("languages.de")),
    shortLabel: "DE",
  },
  {
    value: "hu",
    label: formatTranslation(i18n.t("languages.hu")),
    shortLabel: "HU",
  },
  {
    value: "it",
    label: formatTranslation(i18n.t("languages.it")),
    shortLabel: "IT",
  },
  {
    value: "pl",
    label: formatTranslation(i18n.t("languages.pl")),
    shortLabel: "PL",
  },
  {
    value: "pt",
    label: formatTranslation(i18n.t("languages.pt")),
    shortLabel: "PT",
  },
  {
    value: "pt-BR",
    label: formatTranslation(i18n.t("languages.ptBR")),
    shortLabel: "PT-BR",
  },
  {
    value: "ro",
    label: formatTranslation(i18n.t("languages.ro")),
    shortLabel: "RO",
  },
  {
    value: "sk",
    label: formatTranslation(i18n.t("languages.sk")),
    shortLabel: "SK",
  },
  {
    value: "es",
    label: formatTranslation(i18n.t("languages.es")),
    shortLabel: "ES",
  },
  {
    value: "uk",
    label: formatTranslation(i18n.t("languages.uk")),
    shortLabel: "UA",
  },
  { value: "es-AR", label: formatTranslation(i18n.t("languages.esAR")) },
];
